'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToStep = exports.handleFramedSignupCompleted = exports.handleSignupCompleted = exports.getLoginRedirectUrl = exports.getOnDoneRedirectUrl = exports.getOnCompleteRedirectUrl = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = require('immutable');

var _reactRouterRedux = require('react-router-redux');

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _PortalIdContainer = require('../globals/PortalIdContainer');

var _PortalIdContainer2 = _interopRequireDefault(_PortalIdContainer);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _StepsConfigContainer = require('../globals/StepsConfigContainer');

var _StepsConfigContainer2 = _interopRequireDefault(_StepsConfigContainer);

var _appBasePath = require('../constants/appBasePath');

var _appBasePath2 = _interopRequireDefault(_appBasePath);

var _appStepRoutes = require('../constants/appStepRoutes');

var _getProductIntentLink = require('../utils/getProductIntentLink');

var _getProductIntentLink2 = _interopRequireDefault(_getProductIntentLink);

var _Auth = require('../utils/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _links = require('../utils/links');

var _links2 = _interopRequireDefault(_links);

var _CurrentStepActions = require('./CurrentStepActions');

var _getStepOptions = require('../utils/getStepOptions');

var _getStepOptions2 = _interopRequireDefault(_getStepOptions);

var _specialAndErrorHandlers = require('../../core/constants/specialAndErrorHandlers');

var _specialAndErrorHandlers2 = _interopRequireDefault(_specialAndErrorHandlers);

var _shouldPrependPortalOnStep = require('../utils/shouldPrependPortalOnStep');

var _shouldPrependPortalOnStep2 = _interopRequireDefault(_shouldPrependPortalOnStep);

var _handleFrameRedirect = require('../utils/handleFrameRedirect');

var _handleFrameRedirect2 = _interopRequireDefault(_handleFrameRedirect);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('RouterActions');

function buildRoute(stepName) {
  var signupIntent = _AppConfigContainer2.default.get('baseHistoryPath');
  var basePathName = '' + _appBasePath2.default + signupIntent;
  var nextPath = '/step/' + stepName;
  var portalIdFromContainer = _PortalIdContainer2.default.get();
  if (portalIdFromContainer) {
    nextPath = basePathName + '/' + portalIdFromContainer + nextPath;
  } else {
    // keeping the two conditions separate with the additional `shouldPrepend`
    // to avoid breaking previous assumptions made on having the portal ID in the url
    var portalIdFromParser = _hubspot2.default.get();
    if (portalIdFromParser && (0, _shouldPrependPortalOnStep2.default)(stepName)) {
      nextPath = basePathName + '/' + portalIdFromParser + nextPath;
    } else {
      nextPath = '' + basePathName + nextPath;
    }
  }

  return {
    pathname: nextPath,
    query: _QueryParamsContainer2.default.getJS()
  };
}

var getRedirectUrlParams = function getRedirectUrlParams(portalId) {
  portalId = portalId || _PortalIdContainer2.default.get() || _hubspot2.default.get();
  var intentKey = _AppConfigContainer2.default.get('intentKey');
  var intentParams = (0, _immutable.Map)(_QueryParamsContainer2.default.getJS()).remove('intent');

  var productIntentLink = (0, _getProductIntentLink2.default)(intentKey, intentParams, portalId);

  return { productIntentLink: productIntentLink, portalId: portalId };
};

var getOnCompleteRedirectUrl = exports.getOnCompleteRedirectUrl = function getOnCompleteRedirectUrl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$user = options.user,
      user = _options$user === undefined ? null : _options$user,
      _options$survey = options.survey,
      survey = _options$survey === undefined ? new _immutable.Map() : _options$survey;

  var _getRedirectUrlParams = getRedirectUrlParams(),
      productIntentLink = _getRedirectUrlParams.productIntentLink,
      portalId = _getRedirectUrlParams.portalId;

  var maybePromiseOnCompleteRedirectUrl = _AppConfigContainer2.default.get('onComplete')(productIntentLink, portalId, _Auth2.default.get(), { user: user, survey: survey });

  var maybePromises = [maybePromiseOnCompleteRedirectUrl];

  return Promise.all(maybePromises).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        url = _ref2[0];

    if (url) {
      return url.replace('local', 'app');
    }

    LOG.error('Empty redirect URL', {
      extra: {
        user: user,
        survey: survey,
        productIntentLink: productIntentLink,
        portalId: portalId
      }
    });

    return _links2.default.dashboard();
  });
};

var getOnDoneRedirectUrl = exports.getOnDoneRedirectUrl = function getOnDoneRedirectUrl(id) {
  var _getRedirectUrlParams2 = getRedirectUrlParams(id),
      productIntentLink = _getRedirectUrlParams2.productIntentLink,
      portalId = _getRedirectUrlParams2.portalId;

  return _AppConfigContainer2.default.get('onDone')(productIntentLink, portalId);
};

// used by default on failure after portal creation.
// overriden for Google logins without portal creation
// note: for 3-step flows, this means it'll skip the 3rd step when there's an auth failure.
// this fallback is a last resort logic
var getLoginRedirectUrl = exports.getLoginRedirectUrl = function getLoginRedirectUrl() {
  var onLoginRedirectLinkParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var onLogin = _AppConfigContainer2.default.get('onLogin');
  return onLogin ? onLogin(onLoginRedirectLinkParams) : _links2.default.step(_appStepRoutes.GETTING_STARTED_FALLBACK, onLoginRedirectLinkParams);
};

var handleSignupCompleted = exports.handleSignupCompleted = function handleSignupCompleted(_ref3) {
  var user = _ref3.user,
      survey = _ref3.survey;
  return function () {
    getOnCompleteRedirectUrl({ user: user, survey: survey }).then(function (url) {
      window.top.location.href = url;
    });
  };
};

var handleFramedSignupCompleted = exports.handleFramedSignupCompleted = function handleFramedSignupCompleted() {
  (0, _handleFrameRedirect2.default)(getOnCompleteRedirectUrl());
};

var goToStep = exports.goToStep = function goToStep(stepKey) {
  return function (dispatch) {
    var stepKeys = _StepsConfigContainer2.default.getKeys();

    var key = void 0;
    // if is a special step can go to it
    if (_specialAndErrorHandlers2.default.get(stepKey) || stepKeys && stepKeys.indexOf(stepKey) !== -1) {
      key = stepKey;
    } else if (stepKeys) {
      key = stepKeys.first();
    }

    var stepOptions = void 0;
    if (key) {
      stepOptions = (0, _getStepOptions2.default)(key);
    } else {
      LOG.error('Unable to get step options for step ', {
        extra: {
          stepKeys: stepKeys,
          stepKey: stepKey
        }
      });
    }
    var totalSteps = void 0;
    if (_specialAndErrorHandlers2.default.get(stepKey)) {
      totalSteps = stepKeys ? (0, _getStepOptions2.default)(stepKeys.first()).get('totalSteps') : null;
    } else {
      totalSteps = stepOptions ? stepOptions.get('totalSteps') : null;
    }
    var number = stepOptions ? stepOptions.get('stepNumber') : null;
    dispatch((0, _CurrentStepActions.updateCurrentStep)({ key: key, number: number, totalSteps: totalSteps }));

    return dispatch((0, _reactRouterRedux.push)(buildRoute(stepKey)));
  };
};